/* eslint-disable react/jsx-first-prop-new-line */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ButtonSpinner from './ButtonSpinner';

import './style.scss';

/**
 * Button
 * @param {String}   type  - cta|danger|default[default]|secondary
 * @param {String}   size  - xl (default: none)
 * @param {Boolean}  isDisabled - false[default]
 * @param {Boolean}  isLoading - false[default]
 * @param {Boolean}  isIconOnlyOnMobile - false[default]
 * @param {String}   label - Ok[default]
 * @param {Number}   count - to add a number indicator
 * @param {Number}   countColour|countColor - to add background colour code to
 * the count part. options: green[default]|white|red|yellow|light|dark
 * @param {String}   href  - to make link as button
 * @param {String}   icon  - icon className, eg: zelpicons-menu, default: none
 * @param {Number}   iconVersion - default 1 and we can give it 2
 * @param {() => void}  onClick - to make normal button with onClick handler
 *  (this is default one if you use href and this at the same time).
 */

const Button = (props) => {

    const [isExtraSmallScreen, setIsExtraSmallScreen] = useState(window.innerWidth <= 375);

    useEffect(() => {
        const setScreenSize = () => {
            setIsExtraSmallScreen(window.innerWidth <= 375);
        }
        window.addEventListener('resize', setScreenSize);
        return () => window.removeEventListener('resize', setScreenSize);
    }, []);

    return (
        <ButtonContainer
            classNames={`zelp-button
            ${props.type ? 'zelp-button__' + props.type : 'zelp-button__default'}
            ${props.size === 'xl' || props.size === 'XL' ? 'zelp-button__xl' : ''}
            ${props.isIconOnlyOnMobile ? 'zelp-button__icon-only-on-mobile' : ''}
            ${!props.label ? 'zelp-button__icon-only' : ''}
            ${props.isDisabled ? 'zelp-button__disabled' : ''}
            ${props.count ? 'zelp-button__has-count' : ''}
            ${props.icon && (!isExtraSmallScreen ||
                    (props.size !== 'xl' && props.size !== 'XL')) ? 'zelp-button__has-icon' : ''}
         `}
            {...props}>
            {props.icon && (!isExtraSmallScreen || (props.size !== 'xl' && props.size !== 'XL')) ?
                <div className="zelp-button_icon">
                    <i className={`${props.iconVersion === 2 ? 'zelpicon' : 'zelpicons'} ${props.icon}`}
                        aria-hidden="true" />
                </div> : ''}
            {!props.isRound ? <span className="zelp-button_label">{props.label || 'Ok'}</span> : ''}
            {props.count ? (
                <span
                    className={`zelp-button_count ${props.countColour ||
                        props.countColor ? 'zelp-button_count__' + (props.countColour || props.countColor) : ''}`}>
                    {props.count}
                </span>) : ''}
        </ButtonContainer>
    )
}

/*
 If only icon is provided (label is empty) OR (show only icon on mobile
    flag is true AND screen size is mobile size) THEN apply style
 If size prop is XL make square with rounded border (same size as XL) otherwise make circle
*/

const ButtonContainer = props => {
    // Accessible name: prefer an explicit aria-label, otherwise fall back to the
    // text label (which may be visually hidden for icon-only / icon-only-on-mobile
    // buttons). Purely additive — no visual effect.
    const accessibleName = props['aria-label'] || props.label || undefined;
    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {props.onClick || (!props.href && !props.onClick) ?
                // eslint-disable-next-line react/button-has-type
                <button
                    onClick={(!props.isDisabled && !props.isLoading) ? props.onClick : () => { }}
                    className={props.classNames + ' ' + props.className}
                    disabled={!!props.isDisabled}
                    aria-label={accessibleName}
                    tabIndex={props.tabindex}>
                    {props.isLoading ? <ButtonSpinner isLight={props.type === 'cta' || props.type === 'danger'} />
                        : props.children}
                </button> :
                <Link
                    to={(!props.isDisabled && !props.isLoading) ? props.href : '#'}
                    className={props.classNames + ' ' + props.className}
                    aria-label={accessibleName}
                    tabIndex={props.tabindex}>
                    {props.isLoading ? <ButtonSpinner
                        isLight={props.type === 'cta' || props.type === 'danger'} /> : props.children}
                </Link>}
        </>
    );
}

export default React.memo(Button);
